import { render, staticRenderFns } from "./TaskStatistics.vue?vue&type=template&id=0f104904&"
import script from "./TaskStatistics.vue?vue&type=script&lang=js&"
export * from "./TaskStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports